<header class="header" appScrollDirection [ngClass]="isHeaderMove ? 'header header--scroll' : 'header'">
  <div class="header__overlay" [class.visible]="this.menuOpen()" (click)="closeMenu()"></div>
  <div class="header__container" [class.menu-open]="this.menuOpen()">
    <nav class="header__body" [class.menu-open]="this.menuOpen()">
      <div class="header__logo">
          <a href="#"
             (click)="onLogoClick($event)">
            <img src="/Logos/lexwood-beige.svg" alt="Lexwood Solutions - Timber Flooring Sydney" class="header__logo-icon">
          </a>
      </div>

      @if (this.isMobileWidth) {
        <button
          type="button"
          class="menu-toggle"
          [class.menu-open]="this.menuOpen()"
          (click)="toggleMenu()"
          aria-label="Toggle menu"
          [attr.aria-expanded]="this.menuOpen()">
          <span class="bars">
            <span class="bar"></span>
            <span class="bar"></span>
            <span class="bar"></span>
          </span>
        </button>
      }

      <div class="header__menu menu">
        <ul class="menu__list">
          @for (item of headerItems; track $index) {
            <li class="menu__item">
              <a class="menu__link"
                 [href]="item.link"
                 (click)="onAnchorItemClick($event, item.link, item.scrollOptions)">
                <span class="menu__link-text">{{ item.title }}</span>
              </a>
            </li>
          }
        </ul>
        <div class="header__actions">
          <a href="#"
             class="header__contact-button"
             (click)="onAnchorItemClick($event, '#contact-us', { duration: 700, offset: 80 })">
            Contact
          </a>
        </div>
      </div>
    </nav>
  </div>
</header>
